import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

import { NotificationService } from '../../../notifications/notification.service';
import { CertificationTypeService } from '../certification-type.service';
import {
    CertificationTypeActionTypes, LoadCertificationTypesFail, LoadCertificationTypesSuccess
} from './certification-type.actions';

@Injectable()
export class CertificationTypeEffects {


  constructor(
    private service: CertificationTypeService,
    private actions$: Actions,
    private notificationService: NotificationService,
    private translateService: TranslateService) {
  }


  @Effect({ dispatch: false })
  genericFail$ = this.actions$.pipe(
    ofType<Action & { payload: string }>(
      CertificationTypeActionTypes.LoadCertificationTypesFail,
    ),
    tap(action => this.notificationService.error(action.payload))
  );


  @Effect()
  loadUsers$ = this.actions$.pipe(
    ofType(CertificationTypeActionTypes.LoadCertificationTypes),
    mergeMap(_ =>
      this.service.getAll().pipe(
        map(items => {
          items.forEach(item => item.name = this.translateService.instant(item.name));
          return new LoadCertificationTypesSuccess(items);
        }),
        catchError(err => of(new LoadCertificationTypesFail(err)))
      )
    )
  );

}
